var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:[ _setup.props.value ? 'switch-container' : 'switch-container-active'],on:{"click":_setup.toggleSwitch}},[_c('div',{staticClass:"switch-core"})])
}
var staticRenderFns = []

export { render, staticRenderFns }